<template>
  <!-- 导师辅导广告 -->
  <a class="model teacher" href="/service" target="_blank">
    <div class="title">超级简历辅导</div>
    <img src="https://files.wondercv.com/mentor-img.png" alt="" class="teacher-img">
    <div class="teacher-text">
      业界最顶级的导师辅导，拥有全球名企实战经验，简历修改后获得 <b>2倍以上面试邀请，</b>帮你拿到梦想Offer
    </div>
  </a>
</template>
<script>
export default {
  name: 'Teacher',
}
</script>
<style lang="scss" scoped>
.teacher {
  display: block;
  padding: 22px 20px 10px;
  background: #fff;
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 4px 4px 0 0;
  margin-top: 14px;
  .title {
    color: #404040;
    font-size: 14px;
    margin-bottom: 24px;
    font-weight: bold;
  }
  .teacher-img {
    display: block;
    width: 100%;
  }
  .teacher-text {
    margin-top: 13px;
    line-height: 23px;
    color: #606060;
    b {
      font-weight: 400;
      color: #FF4E4C;
    }
  }
}
.model {
  margin-bottom: 0 !important;
}
</style>
